import {
  MESSAGE_CHANNELS,
  type MessageChannel,
} from "@redotech/effect-api-shared/models/shopper-ai/conversation/message";
import {
  ConversationFilterNames,
  conversationFilterData,
} from "@redotech/effect-api-shared/schema/conversation-filters";
import ChannelsIcon from "@redotech/redo-icons/message-chat-circle.svg";
import { ArrayStringFilterOperator } from "@redotech/redo-model/views/advanced-filters/array-string-filter";
import { AdvancedFilterType } from "@redotech/redo-model/views/advanced-filters/generic-advanced-filter-data";
import type { ArrayStringTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";
import { MessageChannelReadable } from "../ui/thread-channel-ui";

export const ChannelsAdvancedFilter: ArrayStringTableFilter<MessageChannel> = {
  type: AdvancedFilterType.ARRAY_TO_STRING,
  Icon: ChannelsIcon,
  operators: [
    ArrayStringFilterOperator.ANY_OF,
    ArrayStringFilterOperator.NONE_OF,
  ],
  data: conversationFilterData[ConversationFilterNames.CHANNELS],
  itemLabel: "channel",
  itemLabelPlural: "channels",
  values: [...MESSAGE_CHANNELS],
  display: (item: MessageChannel) => MessageChannelReadable[item] ?? item,
  displayName: "Channels",
};
